/**
 * The docs site's outside links — ONE config (design §0.2): header, menu and footer read it. Panel ·
 * Sign up · Support · Status · Contact sales · Terms · Privacy.
 *
 * The panel, the terms and the privacy pages live in the app, which is another site once the docs
 * move out (K104, MOVE.md): `REACT_APP_DOCS_APP_URL` is the app's origin (e.g. https://app.refabric.com).
 * Without it (the `/docs` preview inside the app) they stay same-origin paths.
 *
 * `null` = no address decided yet: the link is not shown anywhere (never a placeholder).
 *
 * The build reads this file too (`scripts/lib/shared.mjs`) and copies it into the site data, so a
 * page always carries the links it was built with.
 */
const APP_ORIGIN = (process.env.REACT_APP_DOCS_APP_URL ?? "").replace(/\/+$/, "");

export interface DeveloperLinks {
  /** The Developers panel — the docs' "Panel" menu link. */
  panel: string;
  /** The app's sign-up page — the header's "Sign up" button. */
  signUp: string;
  /** The docs page that carries the support channels (a docs-root path). */
  support: string;
  /** The public status page — no address decided yet (design §10.4). */
  status: string | null;
  /** A public contact-sales address — none decided yet. */
  contactSales: string | null;
  terms: string;
  privacy: string;
}

export const DEVELOPER_LINKS: DeveloperLinks = {
  panel: `${APP_ORIGIN}/developers`,
  signUp: `${APP_ORIGIN}/signup`,
  support: "/support",
  status: null,
  contactSales: null,
  terms: `${APP_ORIGIN}/terms-of-use`,
  privacy: `${APP_ORIGIN}/privacy-policy`,
};
